
import Vue from 'vue'
import Skeleton from '@/common/components/Skeleton.vue'

export default Vue.extend({
  components: {
    Skeleton
  },
  props: {
    editPatternOptions: {
      type: Array,
      required: true
    },
    loaded: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isShowMoreEditPattern: false
    }
  },
  computed: {
    transformedOptions(): any {
      if (this.editPatternOptions.length > 6 && !this.isShowMoreEditPattern) {
        return this.editPatternOptions.slice(0, 6)
      }
      return this.editPatternOptions
    }
  },
  methods: {
    toggleShowMoreEditPattern() {
      this.isShowMoreEditPattern = !this.isShowMoreEditPattern
    }
  }
})
